import {Link} from '../../../link';
import styles from './prtimes-information-section.module.css';

export type PrtimesInformation = {
  informationId: number;
  text: string;
  link: string;
  displayDate: Date;
};

type Props = {
  readonly informationList?: PrtimesInformation[];
};

export function PrtimesInformationSection({informationList}: Props) {
  const formatDisplayDate = (date: Date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}年${month}月${day}日`;
  };

  if (!informationList || informationList.length === 0) return null;

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>PR TIMESからのお知らせ</h2>
      <ul>
        {informationList?.map((item) => (
          <li key={item.informationId} className={styles.item}>
            {item.link === '' ? (
              <span className={styles.text}>{item.text}</span>
            ) : (
              <Link className={styles.link} to={item.link}>
                {item.text}
              </Link>
            )}
            <time
              className={styles.time}
              dateTime={item.displayDate.toLocaleDateString()}
            >
              {formatDisplayDate(item.displayDate)}
            </time>
          </li>
        ))}
      </ul>
    </section>
  );
}
